"use client";
import { useState } from "react";
import { useEffect } from "react";
import Image from "next/image";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Button from "./go-back-components/button";
import { useTranslations } from "next-intl";

type ImageModalProps = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  squared?: boolean;
};

export default function ImageModal({
  src,
  alt,
  width = 300,
  height = 300,
  squared,
}: ImageModalProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const t = useTranslations("Components.navigation");

  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  return (
    <>
      {/* Thumbnail */}
      <div
        className="cursor-pointer transition-transform duration-200 hover:scale-102"
        onClick={() => setIsOpen(true)}
      >
        <Image
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={` transition-opacity duration-500 ${
            squared
              ? "shadow-md aspect-square object-cover w-full"
              : "shadow-md object-cover w-full"
          } ${loaded ? "opacity-100" : "opacity-0 "}`}
          onLoad={() => setLoaded(true)}
        />
      </div>

      {/* Fullscreen Modal */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-5 backdrop-blur-sm touch-none">
          <div className="absolute top-5 right-5 text-white hover:text-gray-300 transition cursor-pointer">
            <Button
              title={t("close")}
              icon={faClose}
              action={() => setIsOpen(false)}
            />
          </div>

          <Image
            src={src}
            alt={alt}
            width={1000}
            height={1000}
            className={`max-h-full max-w-full object-contain transition-opacity duration-500 ${
              loaded ? "opacity-100" : "opacity-0 "
            }`}
            onLoad={() => setLoaded(true)}
          />
        </div>
      )}
    </>
  );
}
